import { UpdateArtifactRequestSchema, UpdateArtifactResponseSchema } from './update-artifact.schema';
/**
 * Update Artifact Endpoint Contract
 * Updates an existing artifact by ID
 */ export const updateArtifactContract = {
    method: 'PATCH',
    path: '/api/v2/artifact/:id',
    description: 'Update an existing artifact by ID',
    requestSchema: UpdateArtifactRequestSchema,
    responseSchema: UpdateArtifactResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            404: 'Artifact not found'
        }
    }
};

//# sourceMappingURL=update-artifact.contract.js.map